import React from "react"
import usePermission from "hooks/usePermission"
import styles from "./styles.module.scss" // Importing the SCSS module
import { MdAdd } from "react-icons/md"

const url = process.env.REACT_APP_SALES_URL

const PagePlaceholder = ({ children }) => {
  const { hasPermission, img } = usePermission()

  return hasPermission ? (
    children
  ) : (
    <div className={styles.mainContainer}>
      <div
        style={{
          background: hasPermission ? "" : `url(${img})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className={`${styles.pagePlaceholder}`}
      >
        {!hasPermission && <div className={styles.overlay} />}

        <div className={styles.noPermissionContent}>
          <p className={styles.message}>MODULE IS CURRENTLY DISABLED</p>
          <button
            className={styles.enableButton}
            onClick={() => window.open(url, "_blank")}
          >
            <p className={styles.btnTxt}><MdAdd className={styles.icon} /> ENABLE</p>
          </button>
        </div>
      </div>
    </div>
  )
}

export default PagePlaceholder
